import React, { useState } from 'react';
import { Menu, X, ChevronDown, Globe } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0b0014]/95 backdrop-blur-md border-b border-white/5">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <a href="/" className="flex items-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_stock-mirrors/artifacts/gdgmfuzc_2.%20Logo%202.png" 
                alt="Stocks Protocol" 
                className="h-8 sm:h-10 md:h-40 w-auto object-contain"
              />
            </a>
            
          </div>

          {/* Right Side */}
          <div className="flex items-center gap-2 md:gap-3">
            <a 
              href="/explorer" 
              className="hidden md:flex items-center gap-2 px-4 py-2 text-sm font-medium text-purple-400 hover:text-purple-300 border border-purple-500/30 hover:border-purple-500/50 rounded-lg transition-all duration-200"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8"/>
                <path d="m21 21-4.3-4.3"/>
              </svg>
              Explorer
            </a>
            
            <button className="hidden lg:flex items-center gap-1 px-3 py-2 text-sm text-gray-300 hover:text-white transition-colors">
              <Globe size={16} />
              <span>EN</span>
              <ChevronDown size={14} />
            </button>
            
            <a 
              href="/signin" 
              className="hidden md:block px-4 py-2 text-sm font-medium text-white hover:text-purple-300 transition-colors"
            >
              Sign in
            </a>
            
            <a 
              href="/signup" 
              className="hidden md:block px-5 py-2.5 text-sm font-semibold text-white bg-[#7B61FF] hover:bg-[#6B4FFF] rounded-lg transition-all duration-200"
            >
              Create account
            </a>

            {/* Mobile Menu Button */}
            <button 
              className="md:hidden p-2 text-white"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-[#0b0014] border-t border-white/5">
          <nav className="px-6 py-4 space-y-3">
            <a href="/explorer" className="flex items-center gap-2 px-4 py-3 text-base font-medium text-purple-400 hover:bg-white/5 rounded-lg transition-colors">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8"/>
                <path d="m21 21-4.3-4.3"/>
              </svg>
              Explorer
            </a>
            <a href="/signin" className="block px-4 py-3 text-base font-medium text-white hover:bg-white/5 rounded-lg transition-colors">
              Sign in
            </a>
            <a href="/signup" className="block px-4 py-3 text-base font-medium text-white bg-[#7B61FF] hover:bg-[#6B4FFF] rounded-lg transition-colors text-center">
              Create account
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

const NavItem = ({ label, hasDropdown }) => (
  <button className="flex items-center gap-1 px-4 py-2 text-sm font-medium text-gray-300 hover:text-white transition-colors">
    {label}
    {hasDropdown && <ChevronDown size={14} />}
  </button>
);

const MobileNavItem = ({ label }) => (
  <a href="#" className="block px-4 py-3 text-base font-medium text-gray-300 hover:text-white hover:bg-white/5 rounded-lg transition-colors">
    {label}
  </a>
);

export default Header;
